import script from "./MoleculeGoal.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeGoal.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeGoal.vue?vue&type=style&index=0&id=45a19566&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45a19566"]])

export default __exports__